import { useLocation, useNavigate } from "react-router-dom";
import styles from "./PageNotFound.module.scss";
import routes from "@/routes/routes";
import Button from "@/components/Button/Button";

const PageNotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.iconWrapper}>
          <svg
            width="68"
            height="68"
            viewBox="0 0 68 68"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M34 12L56 24V46L34 58L12 46V24L34 12Z"
              stroke="rgb(var(--primary-color))"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M34 12V58"
              stroke="rgb(var(--primary-color))"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M56 24L34 35L12 24"
              stroke="rgb(var(--primary-color))"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M45 30V52"
              stroke="rgb(var(--primary-color))"
              strokeWidth="1.75"
              strokeLinecap="round"
              strokeOpacity="0.75"
            />
            <path
              d="M34 46.5L56 35.5"
              stroke="rgb(var(--primary-color))"
              strokeWidth="1.75"
              strokeLinecap="round"
              strokeOpacity="0.75"
            />
          </svg>
        </div>

        <h1 className={styles.code}>404</h1>

        <h2 className={styles.title}>Route Not Found</h2>

        <p className={styles.message}>
          We couldn&rsquo;t find <b>{location.pathname}</b>. The route you&rsquo;re looking for has been misrouted or does not exist.
        </p>

        <div className={styles.actions}>
          <Button
            className={styles.primaryButton}
            onClick={() => navigate(routes.privateRoutes?.DASHBOARD?.path || "/")}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
            Return to Dashboard
          </Button>

          <Button
            className={styles.secondaryButton}
            outlined
            onClick={() => navigate(-1)}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
            Go Back
          </Button>
        </div>

        <p className={styles.footerNote}>
          Need assistance?{" "}
          <span
            className={styles.supportLink}
            onClick={() => navigate(routes.privateRoutes?.SUPPORT?.path || "/support")}
          >
            Please contact support.
          </span>
        </p>
      </div>
    </div>
  );
};

export default PageNotFound;
